// Port of api/fuel/app/classes/insights/collection/suitability.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'suitability',
    insight: ['suitability.duration', 'suitability.count'],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_collection()) return {}

        var durationType = (filter['suitability.duration'] !== undefined) ? filter['suitability.duration'] : 'max'
        var count = (filter['suitability.count'] !== undefined) ? filter['suitability.count'] : 'any'

        var x = (vars && vars.x !== undefined) ? vars.x : 0
        var y = (vars && vars.y !== undefined) ? vars.y : 0

        if (x === false) x = 0
        if (y === false) y = 0

        var suitability = []

        var countSQL = ''

        if (count !== 'any') {
            countSQL = ' AND g.game_players_min <= ' + count + ' AND g.game_players_max >= ' + count
        }

        var raw = Util.queryFast('\
            SELECT \
                g.game_name AS gn, \
                g.game_id AS g, \
                g.game_weight_avg AS w, \
                g.game_time_max AS x, \
                g.game_time_min AS n, \
                g.game_players_max AS px, \
                g.game_players_min AS pn \
            FROM \
                collection co \
                JOIN \
                game g \
                ON \
                co.game_id = g.game_id \
            WHERE \
                co.user_id IN (' + Util.in(userIndex) + ') \
                AND \
                co.collection_own = 1 \
                AND \
                g.game_weight_avg > 0 \
                AND \
                g.game_time_max > 0 \
                AND \
                g.game_players_min > 0 \
                AND \
                co.collection_expansion = 0 \
                ' + countSQL + ' \
            GROUP BY \
                g.game_id \
            ORDER BY \
                g.game_sortname ASC, \
                g.game_weight_avg ASC \
        ')

        for (var ri = 0; ri < raw.length; ri++) {
            var item = raw[ri]

            var duration = item.x

            if (durationType === 'mid' && item.x > item.n) {
                duration = ((item.x - item.n) / 2) + item.n
            } else if (durationType === 'count' && item.x > item.n && item.px > item.pn) {
                duration = (item.x - item.n) / (item.px - item.pn + 1)
                duration = item.n + (duration * (count - item.pn + 1))
            }

            suitability.push({
                g: parseInt(item.g, 10),
                // PHP-style round-half-away-from-zero so 2.405 → 2.41.
                // JS Math.round uses round-half-to-even on the nearest
                // IEEE 754 float, which gives 2.4 for the string "2.405".
                w: parseFloat(item.w) >= 0
                    ? Math.round(parseFloat(item.w) * 100 + 1e-10) / 100
                    : -Math.round(-parseFloat(item.w) * 100 + 1e-10) / 100,
                t: duration >= 0
                    ? Math.round(duration * 100 + 1e-10) / 100
                    : -Math.round(-duration * 100 + 1e-10) / 100,
                n: item.n
            })
        }

        if (detail) {

            var games = []

            for (var di = 0; di < suitability.length; di++) {
                var ditem = suitability[di]

                var itemX = Math.floor(ditem.t / 60)
                var itemY = Math.floor(ditem.w / 1) - 1

                if (itemX > 5) itemX = 5

                if ((x === false || itemX === x) && (y === false || itemY === y)) {

                    this._references.games.push(ditem.g)

                    games.push({
                        id: ditem.g,
                        time: ditem.t,
                        weight: ditem.w,
                        name: ditem.n
                    })

                }
            }

            return {
                games: games
            }

        } else {

            return {
                suitability: suitability
            }

        }

    }
})
